module.exports = __webpack_public_path__ + "static/media/reports_empty.5e837a10.svg";